import CollectionStatusSelect from "./collection-status-select";



const CollectionFormItems = {
    Status: CollectionStatusSelect,
};

export default CollectionFormItems;